export enum PromotionChallengeReadConditionEnum {
  CHAPTER = 'CHAPTER',
  BOOK = 'BOOK',
}
